import type { SearchResult } from '../../lib/search-result';

/**
 * A screen within the palette. Views form a stack rather than a flat enum because the contact
 * drill-in carries data (which contact) and can be reached from more than one place — Escape
 * has to return wherever the user came from, not to a hardcoded parent.
 */
export type PaletteView =
  | { kind: 'root' }
  | { kind: 'recent' }
  | { kind: 'destinations' }
  /** Everything attached to one contact: their open work, then their record. */
  | { kind: 'contact'; contactId: number; contactName: string }
  /** The full, uncapped result list for a single entity type. */
  | { kind: 'results'; entityType: SearchResult['entityType'] };

export const VIEW_PLACEHOLDER: Record<PaletteView['kind'], string> = {
  root: 'Search, or jump to…',
  recent: 'Search recently visited…',
  destinations: 'Search destinations…',
  contact: 'Search this contact’s tasks…',
  results: 'Refine your search…',
};

/** Label for the chip shown above the input on any non-root view. */
export function viewChipLabel(view: PaletteView): string {
  switch (view.kind) {
    case 'recent':
      return 'Recent';
    case 'destinations':
      return 'Go to';
    case 'contact':
      return view.contactName;
    case 'results':
      return view.entityType === 'contact' ? 'All contacts' : 'All tasks';
    default:
      return '';
  }
}
